import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

/**
 * @param {string[]} classNames
 * @returns {string}
 */
function joinClassNames() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
}

/**
 * @param {string} projectPrefix
 * @returns {{
 *  component: (block: string) => {
 *    block: (...modifiersOrClassNames: (Modifiers | string)[]) => string;
 *    element: (element: string, ...modifiersOrClassNames: (Modifiers | string)[]) => string;
 *  };
 *  state: (stateName: string) => string;
 * }}
 */
function createClassNames(projectPrefix) {
  return {
    component: function component(block) {
      var baseClassName = "".concat(projectPrefix, "-c-").concat(block);
      return {
        block: addModifiers(baseClassName),
        element: function element(_element) {
          for (var _len2 = arguments.length, modifiersOrClassNames = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            modifiersOrClassNames[_key2 - 1] = arguments[_key2];
          }
          return addModifiers("".concat(baseClassName, "__").concat(_element)).apply(void 0, modifiersOrClassNames);
        }
      };
    },
    state: function state(stateName) {
      return "".concat(projectPrefix, "-s-").concat(stateName);
    }
  };
}
/**
 * @param {string} baseClassName
 * @returns {(...modifiersOrClassNames: (Modifiers | string)[]) => string}
 */
function addModifiers(baseClassName) {
  return function () {
    for (var _len3 = arguments.length, modifiersOrClassNames = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      modifiersOrClassNames[_key3] = arguments[_key3];
    }
    return joinClassNames.apply(void 0, [baseClassName].concat(_toConsumableArray(modifiersOrClassNames.flatMap(function (modiferOrClassName) {
      return typeof modiferOrClassName === 'string' ? modiferOrClassName : Object.entries(modiferOrClassName).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          condition = _ref2[1];
        return condition;
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          modifier = _ref4[0];
        return "".concat(baseClassName, "--").concat(modifier);
      });
    }))));
  };
}
var CommonClassNames = createClassNames('dtv-common');

/**
 * @typedef {{ [x: string]: boolean }} Modifiers
 */

export { CommonClassNames, addModifiers, createClassNames, joinClassNames };
//# sourceMappingURL=index.js.map
